export default "__VITE_ASSET__CJ8G2nPA__"